import { Collapse, makeStyles } from '@material-ui/core';
import { TransitionProps } from '@material-ui/core/transitions';
import { TreeItem, TreeItemProps } from '@material-ui/lab';
import React from 'react';
import { useSpring, animated } from 'react-spring/web.cjs'; 

function TransitionComponent(props: TransitionProps) {
    const style = useSpring({
        from: { opacity: 0, transform: 'translate3d(20px,0,0)' },
        to: { opacity: props.in ? 1 : 0, transform: `translate3d(${props.in ? 0 : 20}px,0,0)` },
    });

    return (
        <animated.div style={style}>
            <Collapse {...props} />
        </animated.div>
    );
}

const handleClick = (event: React.MouseEvent) => {
    event.preventDefault();
}

const treeItemStyle = makeStyles(_ => ({
    treeItem: {
        '& .MuiTreeItem-content': {
            alignItems: 'flex-start'
        },
        '& .MuiTreeItem-iconContainer': {
            marginTop: '3px'
        }
    }
}));

const TitleTreeItem : React.FC<TreeItemProps> = (props) => {
    const classes = treeItemStyle();
    return <TreeItem  className={classes.treeItem} onContextMenu={handleClick} {...props} TransitionComponent={TransitionComponent} />
}

export default TitleTreeItem;